module.exports = __webpack_public_path__ + "img/swiper1.1c4ca643.png";